export enum CampDataType {
  Airframe = 'airframe',
  APU = 'apu',
  Engine = 'engine'
}
